// Firebase configuration for LinkedIn Profile Optimizer
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAbwtKe_Rc7N3e1N7lroaBF1cx1VoRIVWc",
  authDomain: "auth.growleads.io",
  projectId: "linkedin-profile-optimiz-2e143",
  storageBucket: "linkedin-profile-optimiz-2e143.firebasestorage.app",
  messagingSenderId: "502589216468",
  appId: "1:502589216468:web:e904973ef28f5b4d104d41",
  measurementId: "G-397B4HP6CC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Configure Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('Google sign-in error:', error);
    return { success: false, error: error.message };
  }
};

// Sign out
export const logOut = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('Sign out error:', error);
    return { success: false, error: error.message };
  }
};

export { auth, googleProvider };
export default app;
